var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container",attrs:{"id":"selector"}},[_c('div',{staticClass:"columns is-centered"},_vm._l((_vm.games),function(ref){
var src = ref.src;
var alt = ref.alt;
var name = ref.name;
var button = ref.button;
return _c('div',{key:name,staticClass:"column is-half"},[_c('figure',{staticClass:"image is-square"},[_c('img',{attrs:{"src":src,"alt":alt}})]),_c('Button',{attrs:{"text":button.text,"event":function () { return _vm.goTo(("/" + name)); }}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }